import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sm:flex sm:items-center sm:justify-between" }
const _hoisted_2 = {
  for: "redirect-label",
  class: "text-white text-ellipsis whitespace-nowrap overflow-hidden"
}
const _hoisted_3 = { class: "flex flex-wrap justify-center items-center gap-2 w-fit" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mx-1 text-xl w-0.5 h-8 bg-white text-white" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Filter favorite", -1)
const _hoisted_6 = { class: "w-full justify-center sm:justify-start sm:w-fit flex flex-wrap items-center gap-2 rounded-md bg-gray-700 p-2 mb-2 sm:mb-4" }
const _hoisted_7 = {
  for: "redirect-label",
  class: "text-white text-ellipsis whitespace-nowrap overflow-hidden"
}
const _hoisted_8 = { class: "flex flex-wrap justify-center items-center gap-2 w-fit" }
const _hoisted_9 = { class: "bg-white rounded-md py-1 sm:py-2 px-2 sm:px-4 mt-2 sm:mt-4" }

import { createVNode, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Modal, Pagination, Switch, TypographyText } from 'ant-design-vue';
import {
	AppstoreOutlined,
	BorderOutlined,
	DeleteFilled,
	EditFilled,
	EyeFilled,
	PictureOutlined,
	PlusOutlined,
	StarFilled,
	SwitcherOutlined,
	VideoCameraOutlined
} from '@ant-design/icons-vue';
import OnlyfansCard from '@/components/disposable/OnlyfansCard.vue';
import ActionButtons from '@/components/shared/ActionButtons.vue';
import ImageLoadingCard from '@/components/shared/ImageLoadingCard.vue';
import { Metadata } from '@/model/api';
import { ActionButton } from '@/model/button';
import { File, Document, DocumentPaginationRequest, DocumentType } from '@/model/document';
import LocalStorageKey from '@/model/key';
import { DocumentViewMode, ActionMode, DocumentTypeFilter } from '@/model/universal';
import { favoriteDocument, getDocumentPagination, deleteDocument } from '@/repository/document';
import { assignWithDetail } from '@/util/universal';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnlyfansView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const actorID = route.params.actorID as string;

const filterButton: { label: string; actions: ActionButton[] } = {
	label: 'Filter',
	actions: [
		{
			tooltip: 'All',
			mode: DocumentTypeFilter.All,
			component: TypographyText,
			props: { content: 'All' },
			activeClass: 'bg-pink-400 !text-black',
			hoverClass: 'hover:bg-pink-400 hover:!text-black',
			action: () => (typeFilter.value = DocumentTypeFilter.All)
		},
		{
			tooltip: 'Video',
			mode: DocumentTypeFilter.Video,
			component: VideoCameraOutlined,
			activeClass: 'bg-green-300 !text-black',
			hoverClass: 'hover:bg-green-300 hover:!text-black',
			action: () => (typeFilter.value = DocumentTypeFilter.Video)
		},
		{
			tooltip: 'Image',
			mode: DocumentTypeFilter.Image,
			component: PictureOutlined,
			activeClass: 'bg-yellow-400 !text-red-600',
			hoverClass: 'hover:bg-yellow-400 hover:!text-red-600',
			action: () => (typeFilter.value = DocumentTypeFilter.Image)
		}
	]
};

const buttons: { label: string; actions: ActionButton[] }[] = [
	{
		label: 'View',
		actions: [
			{
				tooltip: 'Grid View',
				mode: DocumentViewMode.Grid,
				component: AppstoreOutlined,
				activeClass: 'bg-pink-400 !text-black',
				hoverClass: 'hover:bg-pink-400 hover:!text-black',
				action: () => (viewMode.value = DocumentViewMode.Grid)
			},
			{
				tooltip: 'Stack View',
				mode: DocumentViewMode.Stack,
				component: SwitcherOutlined,
				activeClass: 'bg-green-300 !text-black',
				hoverClass: 'hover:bg-green-300 hover:!text-black',
				action: () => (viewMode.value = DocumentViewMode.Stack)
			},
			{
				tooltip: 'List View',
				mode: DocumentViewMode.List,
				component: BorderOutlined,
				activeClass: 'bg-yellow-400 !text-red-600',
				hoverClass: 'hover:bg-yellow-400 hover:!text-red-600',
				action: () => (viewMode.value = DocumentViewMode.List)
			}
		]
	},
	{
		label: 'Action',
		actions: [
			{
				tooltip: 'Favorite',
				mode: ActionMode.Favorite,
				component: StarFilled,
				activeClass: 'bg-yellow-400 !text-red-600',
				hoverClass: 'hover:bg-yellow-400 hover:!text-red-600',
				action: () => (actionMode.value = ActionMode.Favorite)
			},
			{
				tooltip: 'View',
				mode: ActionMode.View,
				component: EyeFilled,
				activeClass: 'bg-pink-400 !text-black',
				hoverClass: 'hover:bg-pink-400 hover:!text-black',
				action: () => (actionMode.value = ActionMode.View)
			},
			{
				tooltip: 'Add',
				mode: ActionMode.Add,
				component: PlusOutlined,
				activeClass: 'bg-green-300 !text-black',
				hoverClass: 'hover:bg-green-300 hover:!text-black',
				action: () => router.push({ name: 'Create Onlyfans' })
			},
			{
				tooltip: 'Edit',
				mode: ActionMode.Edit,
				component: EditFilled,
				activeClass: 'bg-blue-400 !text-white',
				hoverClass: 'hover:bg-blue-400 hover:!text-white',
				action: () => (actionMode.value = ActionMode.Edit)
			},
			{
				tooltip: 'Delete',
				mode: ActionMode.Delete,
				component: DeleteFilled,
				activeClass: 'bg-red-500 !text-white',
				hoverClass: 'hover:bg-red-500 hover:!text-white',
				action: () => (actionMode.value = ActionMode.Delete)
			}
		]
	}
];

const metadata = ref<Metadata>(initialMetadata());
function initialMetadata(): Metadata {
	return {
		limit: Number(route.query.limit) || 10,
		offset: 0,
		totalItem: 0,
		totalPage: 0,
		currentPage: Number(route.query.page) || 1
	};
}

const onlyfans = ref<Document[]>([]);
const isFetching = ref(false);
const checkedFavorite = ref(Boolean(route.query?.isFavorite) || false);
const typeFilter = ref<DocumentTypeFilter>(
	(route.query?.type as DocumentTypeFilter) || DocumentTypeFilter.All
);
const viewMode = ref(
	assignWithDetail<DocumentViewMode>(
		Object.values(DocumentViewMode),
		DocumentViewMode.Grid,
		localStorage.getItem(LocalStorageKey.DocumentViewMode) as DocumentViewMode
	)
);
const actionMode = ref(
	assignWithDetail<string>(
		Object.values(ActionMode),
		ActionMode.View,
		localStorage.getItem(LocalStorageKey.DocumentActionMode)
	)
);

fetchData();
async function fetchData() {
	const query: DocumentPaginationRequest = {
		page: metadata.value.currentPage,
		offset: metadata.value.offset,
		limit: metadata.value.limit,
		sort: 'sub_id desc',
		isFavorite: checkedFavorite.value,
		documentType: DocumentType.Onlyfans,
		metadataID: actorID,
		mediaType: [DocumentTypeFilter.Video, DocumentTypeFilter.Image].includes(typeFilter.value)
			? typeFilter.value
			: undefined
	};
	router.replace({
		query: {
			page: metadata.value.currentPage,
			limit: metadata.value.limit,
			isFavorite: checkedFavorite.value ? 'true' : undefined,
			type: [DocumentTypeFilter.Video, DocumentTypeFilter.Image].includes(typeFilter.value)
				? typeFilter.value
				: undefined
		}
	});
	isFetching.value = true;
	const data = await getDocumentPagination(query);
	if (data) {
		onlyfans.value = data.data || [];
		metadata.value = data.metadata;
		isFetching.value = false;
		if (metadata.value.totalPage > 0 && (!data.data || !data.data.length)) {
			metadata.value.currentPage = metadata.value.totalPage;
		}
	}
}

async function onlyfanCardAction(onlyfan: Document, file: File) {
	switch (actionMode.value) {
		case ActionMode.Favorite:
			if (viewMode.value === DocumentViewMode.Stack) {
				const isFavorite = onlyfan.files.filter((f) => f.isFavorite).length > 0;
				onlyfan.files.forEach((f) => (f.isFavorite = !isFavorite));
				await favoriteDocument(onlyfan.documentUUID, !isFavorite);
			} else {
				file.isFavorite = !file.isFavorite;
				await favoriteDocument(onlyfan.documentUUID, file.isFavorite, file.id);
			}
			return;

		case ActionMode.Edit:
			await router.push({
				path: `/onlyfans/${onlyfan.metadata.metadataID}/update/${onlyfan.documentUUID}`
			});
			return;

		case ActionMode.Delete:
			Modal.confirm({
				title: 'Delete Onlyfans',
				icon: createVNode(DeleteFilled),
				content: `Do you want to delete ${viewMode.value !== DocumentViewMode.Stack ? 1 : onlyfan.files.length} onlyfans${onlyfan.files.length > 1 && viewMode.value === DocumentViewMode.Stack ? 's' : ''} right?`,
				okText: 'Yes',
				cancelText: 'No',
				async onOk() {
					await deleteDocument(
						onlyfan.documentUUID,
						viewMode.value !== DocumentViewMode.Stack ? file.id : undefined
					);
					await fetchData();
				}
			});
			return;
	}
}

watch(
	() => metadata?.value.currentPage,
	async () => (metadata?.value.currentPage !== 0 ? await fetchData() : {})
);
watch(
	() => metadata?.value.limit,
	async () => await fetchData()
);
watch(
	() => checkedFavorite.value,
	async () => await fetchData()
);
watch(typeFilter, async () => await fetchData());
watch(viewMode, () => localStorage.setItem(LocalStorageKey.DocumentViewMode, viewMode.value));
watch(actionMode, () => localStorage.setItem(LocalStorageKey.DocumentActionMode, actionMode.value));

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttons, (button, buttonIndex) => {
        return _createElementVNode("div", {
          key: buttonIndex,
          class: "w-full justify-center sm:justify-start sm:w-fit flex flex-wrap items-center gap-2 rounded-md bg-gray-700 p-2 my-2 sm:my-4"
        }, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(button.label), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ActionButtons, {
              actions: button.actions,
              mode: !buttonIndex ? viewMode.value : actionMode.value,
              placement: 
						(index) =>
							index === button.actions.length - 1 && buttonIndex === buttons.length - 1
								? 'topRight'
								: 'top'
					
            }, null, 8, ["actions", "mode", "placement"])
          ]),
          (!buttonIndex)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_4,
                _createVNode(_component_a_tooltip, { placement: "top" }, {
                  title: _withCtx(() => [
                    _hoisted_5
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(Switch), {
                      checked: checkedFavorite.value,
                      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((checkedFavorite).value = $event))
                    }, {
                      checkedChildren: _withCtx(() => [
                        _createVNode(_unref(StarFilled))
                      ]),
                      _: 1
                    }, 8, ["checked"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(filterButton.label), 1),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(ActionButtons, {
          actions: filterButton.actions,
          mode: typeFilter.value,
          placement: () => 'top'
        }, null, 8, ["actions", "mode"])
      ])
    ]),
    _createVNode(ImageLoadingCard, {
      "is-fetching": isFetching.value,
      limit: metadata.value.limit,
      "view-mode": viewMode.value
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(onlyfans.value, (onlyfan, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewMode.value === _unref(DocumentViewMode).Stack
					? onlyfan.files.slice(0, 1)
					: onlyfan.files, (file, idx) => {
              return (_openBlock(), _createBlock(OnlyfansCard, {
                key: idx,
                viewMode: viewMode.value,
                "onUpdate:viewMode": _cache[1] || (_cache[1] = ($event: any) => ((viewMode).value = $event)),
                actionMode: actionMode.value,
                file: file,
                onlyfan: onlyfan,
                total: onlyfans.value.map((i) => i.files.length).reduce((p, c) => (c += p), 0),
                current: 
						onlyfans.value
							.slice(0, index)
							.map((i) => i.files.length)
							.reduce((p, c) => (c += p), 0) +
						idx +
						1
					,
                stackCard: {
						image: onlyfan.files.filter((f) => f.mimeType.startsWith('image/'))?.length || 0,
						video: onlyfan.files.filter((f) => f.mimeType.startsWith('video/'))?.length || 0
					},
                isFavorite: 
						file.isFavorite ||
						(viewMode.value === _unref(DocumentViewMode).Stack &&
							onlyfan.files.findIndex((f) => f.isFavorite) !== -1)
					,
                onClick: onlyfanCardAction
              }, null, 8, ["viewMode", "actionMode", "file", "onlyfan", "total", "current", "stackCard", "isFavorite"]))
            }), 128))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["is-fetching", "limit", "view-mode"]),
    (!isFetching.value && !onlyfans.value.length)
      ? (_openBlock(), _createBlock(_component_a_empty, {
          key: 0,
          class: "mt-2 sm:mt-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(Pagination), {
        current: metadata.value.currentPage,
        "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((metadata.value.currentPage) = $event)),
        "page-size": metadata.value.limit,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((metadata.value.limit) = $event)),
        total: metadata.value.totalItem,
        "show-total": (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        "show-size-changer": "",
        "show-quick-jumper": "",
        onChange: _cache[4] || (_cache[4] = 
				(page, pageSize) => {
					metadata.value.currentPage = page;
					metadata.value.limit = pageSize;
				}
			)
      }, null, 8, ["current", "page-size", "total", "show-total"])
    ])
  ], 64))
}
}

})